'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');
var util = require('./util.js');
var message = require('../adapter/messages/message.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Messages {
  get(lang, userName) {
    return __async(this, null, function* () {
      userName = util.getUserName("messages.get", userName);
      const params = { userName, lang };
      const res = yield index.adapter.messages.filter(params);
      return res.map((msg) => message.unlocalize(msg, lang));
    });
  }
  archive(messageId, userName) {
    userName = util.getUserName("messages.archive", userName);
    const params = { userName, messageId };
    return index.adapter.messages.archive(params);
  }
  markAsRead(messageId, userName) {
    userName = util.getUserName("messages.markAsRead", userName);
    const params = { userName, messageId };
    return index.adapter.messages.markAsRead(params);
  }
}
const messages = new Messages();

exports.messages = messages;
